import { Component, ojs, app, state, v } from "modular-openscriptjs";
import { pageInfo, scrollToTop } from "../../../helpers";
import SolidIcon from "../../Blocks/SolidIcon";

const h = app("h");
const router = app("router");

ojs(SolidIcon);

export default class ManageInventory extends Component {
  businessId = null;

  render() {
    this.businessId = router.params.companyId;
    const businessName = window.currentCompany?.name || "Business";

    pageInfo(`Manage Inventory - ${businessName}`);
    scrollToTop();

    return h.div(
      { class: "min-vh-100 py-5 mb-5 py-md-5" },
      h.div(
        { class: "container" },
        // Header
        h.div(
          { class: "mb-5 d-flex align-items-center gap-3" },
          h.button(
            {
              class: "btn btn-white border shadow-sm rounded-circle p-2",
              listeners: {
                click: () => history.back(),
              },
            },
            h.SolidIcon("arrow-left"),
          ),
          h.h2({ class: "fw-bold mb-0" }, "Manage Inventory"),
        ),

        h.div(
          { class: "row g-4" },
          this.renderActionCard(
            "Add Products from Images",
            "Upload Menus or Images and your AI assistant will extract and add your products to your inventory",
            "images", 
            "info",
            () => router.to("business.products.add_images", { companyId: this.businessId })
          ),
          this.renderActionCard(
            "Add New Product with Text",
            "Manually enter product details",
            "pencil-square",
            "primary",
            () => router.to("business.products.add", { companyId: this.businessId })
          ),
          this.renderActionCard(
            "View Inventory",
            "Manage existing products and stock",
            "list-ul",
            "success",
            () => router.to("app.search")
          ),
        )
      ),
    );
  }

  renderActionCard(title, description, icon, color, onclick) {
    return h.div(
      { class: "col-12 col-md-6" },
      h.div(
        {
          class: "card border-0 shadow-sm h-100 cursor-pointer hover-shadow transition-all",
          style: "border-radius: 20px;",
          listeners: {
            click: onclick,
          },
          role: "button",
        },
        h.div(
          { class: "card-body p-4 d-flex align-items-center gap-4" },
          h.div(
            {
              class: `bg-${color}-subtle text-${color} rounded-4 p-4 d-flex align-items-center justify-content-center`,
              style: "width: 80px; height: 80px;",
            },
            h.i({ class: `bi bi-${icon} fs-1` }),
          ),
          h.div(
            {},
            h.h4({ class: "fw-bold mb-2" }, title),
            h.p({ class: "text-muted mb-0" }, description),
          ),
        ),
      ),
    );
  }
}

ojs(ManageInventory);
